import axios from "../../Utils/axiosInstance";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const login = (loginDetails) => {
  const email = loginDetails.email;
  const pwd = loginDetails.password;
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LOGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/admin/login`,
        { email, pwd },
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LOGIN_SUCCESS", payload: data });
        if (data.data.token) {
          localStorage.setItem("userInfo", JSON.stringify(data));
          localStorage.setItem("loginTime", Date.now());
        }
        toast.success("Logged In!");
      } else {
        dispatch({ type: "LOGIN_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "LOGIN_FAIL", payload: error?.response?.data?.message });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const loginPayExec = (loginDetails) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LOGIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/staff/login`,
        loginDetails,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "PAY_EXEC_LOGIN_SUCCESS", payload: data });
        if (data.data.token) {
          localStorage.setItem("userInfo", JSON.stringify(data));
        }
        toast.success("Logged In!");
      } else {
        dispatch({ type: "PAY_EXEC_LOGIN_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "PAY_EXEC_LOGIN_FAIL",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const forgotPass = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "FORGOT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/admin/forgot-password`,
        { email },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ email: email, type: "FORGOT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "FORGOT_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "FORGOT_FAIL",
        payload: error?.response?.data?.message,
      });
    }
  };
};

export const resetPass = (email, pwd) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "RESET_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/admin/reset-password`,
        { email, pwd },
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "RESET_SUCCESS", payload: data });
      } else {
        dispatch({ type: "RESET_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "RESET_FAIL", payload: error?.response?.data?.message });
    }
  };
};

export const logout = () => async (dispatch) => {
  localStorage.removeItem("userInfo");
  dispatch({ type: "LOGOUT" });
  toast.success("Logged Out!");
};

export const sendFirebaseToken = (tokenData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "SEND_TOKEN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/admin/update-token`,
        tokenData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "SEND_TOKEN_SUCCESS", payload: data });
      } else {
        dispatch({ type: "SEND_TOKEN_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "SEND_TOKEN_FAILED",
        payload: error?.response?.data?.message,
      });
    }
  };
};

//Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "CLEAR_ERRORS" });
};


export const fetchNotifications = (page = 1, limit = 10, order = -1, is_read = false) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_NOTIFICATIONS_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const payload = {
        page,
        limit,
        order,
        is_read,
      };

      const { data } = await axios.post(
        `${BASE_URL}/notifications/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "FETCH_NOTIFICATIONS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "FETCH_NOTIFICATIONS_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "FETCH_NOTIFICATIONS_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to fetch notifications");
    }
  };
};

export const markNotificationsRead = (notifications = []) => {
  return async (dispatch) => {
    dispatch({ type: "MARK_NOTIFICATIONS_READ_REQUEST" });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const payload = {
        notifications,
      };

      const { data } = await axios.post(
        `${BASE_URL}/notifications/marked-read`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "MARK_NOTIFICATIONS_READ_SUCCESS", payload: data });
        // toast.success("Notifications marked as read");
      } else {
        dispatch({ type: "MARK_NOTIFICATIONS_READ_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "MARK_NOTIFICATIONS_READ_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Failed to mark notifications as read");
    }
  };
};
